'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from './UiComponent.js';
import {RelativeContainer} from './RelativeContainer.js';
import {SlideBar} from './SlideBar.js';

const privateMap = util.createPrivateMapper();

export class ScrollPanel {
  constructor(domEl, contentDomEl, options){
    const pv = privateMap(this);
    pv.domEl = domEl;
    pv.scrollPosition = new Point2D();
    pv.contentDomEl = contentDomEl;
    pv.verticalScrollBar = options.verticalScrollBar;
    pv.horizontalScrollBar = options.horizontalScrollBar;
    pv.scrollContainer = domUtil.createElement('div');
    domUtil.setStyle(pv.domEl, 'overflow', 'hidden');
    domUtil.setStyle(pv.scrollContainer, 'overflow', 'scroll');
    domUtil.asAbsolute(pv.scrollContainer);

    domEl.insertBefore(pv.scrollContainer, pv.contentDomEl);
    pv.scrollContainer.appendChild(pv.contentDomEl);

    domUtil.addEventListener(pv.verticalScrollBar.domEl, 'ui.change', (ev) => {
      pv.scrollPosition.y = ev.detail;
      pv.scrollContainer.scrollTop = pv.scrollPosition.y;
    });
    domUtil.addEventListener(pv.horizontalScrollBar.domEl, 'ui.change', (ev) => {
      pv.scrollPosition.x = ev.detail;
      pv.scrollContainer.scrollLeft = pv.scrollPosition.x;
    });

    domUtil.addEventListener(pv.scrollContainer, 'scroll', (ev) => {
      pv.verticalScrollBar.setPosition(pv.scrollContainer.scrollTop, true, true);
      pv.horizontalScrollBar.setPosition(pv.scrollContainer.scrollLeft, true, true);
    });

    pv.verticalScrollBar.setPosition(0);
    pv.horizontalScrollBar.setPosition(0);

    this.applySize();
  }

  applySize(){
    const pv = privateMap(this);
    const size = domUtil.getSize(pv.domEl);

    domUtil.setSizeXY(pv.scrollContainer, 100, 100);
    domUtil.setSize(pv.scrollContainer, size.add(domUtil.getScrollBarSize(pv.scrollContainer)));
    pv.verticalScrollBar.setTerms({
      min: 0, max: pv.scrollContainer.scrollHeight, cursorRange: size.y
    });
    pv.horizontalScrollBar.setTerms({
      min: 0, max: pv.scrollContainer.scrollWidth, cursorRange: size.x
    });
    pv.verticalScrollBar.applySize();
    pv.horizontalScrollBar.applySize();

    pv.verticalScrollBar.setPosition(pv.scrollContainer.scrollTop, true, true);
    pv.horizontalScrollBar.setPosition(pv.scrollContainer.scrollLeft, true, true);
  }
}
